export default [
	{
		modulo: 23,
		privilegio: 24,
		routerName: 'escala-tripulacao',
		routerPath: '/escala-tripulacao',
		componentName: 'EscalaTripulacao',
		componentPath: 'modules/layout/gestao-escala/escala/main'
	},
	{
		modulo: 23,
		privilegio: 24,
		routerName: 'escala-legenda',
		routerPath: '/escala-legenda',
		componentName: 'EscalaLegenda',
		componentPath: 'modules/layout/gestao-escala/cadastro-legenda/main'
	},
	{
		modulo: 23,
		privilegio: 24,
		routerName: 'escala-situacao-tripulacao',
		routerPath: '/escala-situacao-tripulacao',
		componentName: 'EscalaSituacaoTripulacao',
		componentPath: 'modules/layout/gestao-escala/situacao-tripulacao/main'
	},
	{
		modulo: 23,
		privilegio: 24,
		routerName: 'escala-jornada-trabalho-folga',
		routerPath: '/escala-jornada-trabalho-folga',
		componentName: 'EscalaJornadaTrabalhoFolga',
		componentPath: 'modules/layout/gestao-escala/jornada-trabalho-folga/main'
	}
]
